/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_A4Inputs */

const en_simple_oto_faq_a4 = /** @type {(inputs: Simple_Oto_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep explains the problem in plain words and offers to restore the last working version, skip that step, or bring in a person at a fixed price.`)
};

const id_simple_oto_faq_a4 = /** @type {(inputs: Simple_Oto_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep menjelaskan masalahnya dalam bahasa biasa, menawarkan kembali ke versi terakhir yang jalan, melewati langkah itu, atau memanggil manusia dengan harga tetap.`)
};

/**
* | output |
* | --- |
* | "Bystep explains the problem in plain words and offers to restore the last working version, skip that step, or bring in a person at a fixed price." |
*
* @param {Simple_Oto_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_a4 = /** @type {((inputs?: Simple_Oto_Faq_A4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_A4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_a4(inputs)
	return en_simple_oto_faq_a4(inputs)
});